import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CalendarV2 from './admin/CalendarV2';

export default function CalendarPage() {
  return (
    <div className="min-h-screen bg-gray-100" data-testid="calendar-page">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-[1920px] mx-auto px-4 py-3 flex items-center gap-4">
          <Link 
            to="/admin"
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            data-testid="calendar-back-link"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="text-sm font-medium">Назад</span>
          </Link>
          <div className="h-6 w-px bg-gray-300" />
          <h1 className="text-xl font-bold text-gray-800" data-testid="calendar-page-title">
            Календарь рейсов
          </h1>
        </div>
      </div>

      {/* Calendar - Full width */}
      <div className="p-4 max-w-[1920px] mx-auto">
        <CalendarV2 fullWidth={true} />
      </div>
    </div>
  );
}
